import { FC } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import { BreadCrumbView } from 'src/components/breadcrumbs';
import { Helmet } from 'react-helmet-async';
import { CustomerView } from 'src/containers/customer/customerView';

export const CustomersManagement: FC = () => {
  const breadCrumbsDetails = [
    {
      url: '/dashboard/technicians/customers',
      label: 'Customers'
    }
  ];
  return (
    <>
      <Helmet>
        <title>Search Customers | ServCare</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          flexGrow: 1,
          px: 1
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ pt: 4 }}>
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                pb: 3
              }}
            >
              <Typography
                color="textPrimary"
                variant="h4"
              >
                Search Customers
              </Typography>
            </Box>
            <Box
              paddingBottom={2}
            >
              <BreadCrumbView breadCrumbs={breadCrumbsDetails} />
            </Box>
            <Divider />
          </Box>
          <CustomerView enableRaiseRequest={false} />
        </Box>
      </Box>
    </>
  );
};
